import KeyValue from './KeyValue';
import type { KeyValueModel, KeyValueProps } from './KeyValue.types';

export type { KeyValueModel, KeyValueProps };

export { KeyValue };
export default KeyValue;
